import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T /*| null*/;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
};

export type ConditionGroupInput = {
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  conjunction?: InputMaybe<ConjunctionOperator>;
};

export type ConditionInput = {
  name: Scalars['String'];
  operator: Scalars['String'];
  value: Scalars['String'];
};

export enum ConjunctionOperator {
  And = 'AND',
  Or = 'OR'
}

export type DefaultIndexDoc = {
  __typename?: 'DefaultIndexDoc';
  body?: Maybe<Scalars['String']>;
  comment?: Maybe<Scalars['Int']>;
  content_type?: Maybe<Scalars['String']>;
  content_type_1?: Maybe<Scalars['String']>;
  created?: Maybe<Scalars['Int']>;
  field_homepage?: Maybe<Scalars['String']>;
  field_image_position_1?: Maybe<Scalars['String']>;
  field_image_position_2?: Maybe<Scalars['String']>;
  field_image_url?: Maybe<Scalars['String']>;
  field_image_url_1?: Maybe<Scalars['String']>;
  field_logo_1?: Maybe<Scalars['String']>;
  field_logo_2?: Maybe<Scalars['String']>;
  field_logo_3?: Maybe<Scalars['String']>;
  field_logo_4?: Maybe<Scalars['String']>;
  field_logo_margin_1?: Maybe<Scalars['Boolean']>;
  field_logo_margin_2?: Maybe<Scalars['Boolean']>;
  field_logo_margin_3?: Maybe<Scalars['Boolean']>;
  field_logo_margin_4?: Maybe<Scalars['Boolean']>;
  field_recommended?: Maybe<Scalars['String']>;
  field_recommended_ukrajinu?: Maybe<Scalars['String']>;
  field_short_description?: Maybe<Scalars['String']>;
  field_sub_title?: Maybe<Scalars['String']>;
  field_summary?: Maybe<Scalars['String']>;
  field_video_id?: Maybe<Scalars['String']>;
  field_video_platform?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['ID']>;
  page_name?: Maybe<Array<Maybe<Scalars['String']>>>;
  page_name_1?: Maybe<Array<Maybe<Scalars['String']>>>;
  partneri?: Maybe<Array<Maybe<Scalars['Int']>>>;
  path_page?: Maybe<Array<Maybe<Scalars['String']>>>;
  path_partners?: Maybe<Scalars['String']>;
  path_people?: Maybe<Scalars['String']>;
  path_questions?: Maybe<Scalars['String']>;
  path_school?: Maybe<Scalars['String']>;
  path_tag?: Maybe<Scalars['String']>;
  published?: Maybe<Scalars['String']>;
  skoly?: Maybe<Array<Maybe<Scalars['Int']>>>;
  stitky?: Maybe<Array<Maybe<Scalars['Int']>>>;
  summary?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  url: Scalars['String'];
  weight?: Maybe<Scalars['Int']>;
};

export type Description = {
  __typename?: 'Description';
  value?: Maybe<Scalars['String']>;
};

export type Entity = {
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
};

export type EntityQueryFilterConditionInput = {
  field: Scalars['String'];
  operator?: InputMaybe<QueryOperator>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type EntityQueryFilterInput = {
  conditions?: InputMaybe<Array<InputMaybe<EntityQueryFilterConditionInput>>>;
};

export type EntityQueryResult = {
  __typename?: 'EntityQueryResult';
  entities?: Maybe<Array<Maybe<Entity>>>;
};

export type EntityQuerySortInput = {
  direction?: InputMaybe<SortOrder>;
  field: Scalars['String'];
};

export type ExternalLink = {
  __typename?: 'ExternalLink';
  title?: Maybe<Scalars['String']>;
  url?: Maybe<Path>;
};

export type FacetInput = {
  field?: InputMaybe<Scalars['String']>;
  limit?: InputMaybe<Scalars['Int']>;
  min_count?: InputMaybe<Scalars['Int']>;
  missing?: InputMaybe<Scalars['Boolean']>;
  operator?: InputMaybe<Scalars['String']>;
};

export type Facets = {
  __typename?: 'Facets';
  name?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<FacetsValue>>>;
};

export type FacetsValue = {
  __typename?: 'FacetsValue';
  count?: Maybe<Scalars['Int']>;
  filter?: Maybe<Scalars['String']>;
};

export type FieldTags = {
  __typename?: 'FieldTags';
  targetId?: Maybe<Scalars['Int']>;
};

export type FieldVideoPlatform = {
  __typename?: 'FieldVideoPlatform';
  targetId?: Maybe<Scalars['Int']>;
};

export type FulltextInput = {
  fields?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  keys: Array<InputMaybe<Scalars['String']>>;
};

export type Parent = {
  __typename?: 'Parent';
  entities?: Maybe<Array<Maybe<ParentEntity>>>;
};

export type ParentEntity = {
  __typename?: 'ParentEntity';
  entityId?: Maybe<Scalars['String']>;
};

export type Path = {
  __typename?: 'Path';
  path?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  searchAPISearch?: Maybe<SearchApiSearch>;
  taxonomyTermQuery?: Maybe<EntityQueryResult>;
};


export type QuerySearchApiSearchArgs = {
  condition_group?: InputMaybe<ConditionGroupInput>;
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>>>;
  facets?: InputMaybe<Array<InputMaybe<FacetInput>>>;
  fulltext?: InputMaybe<FulltextInput>;
  index_id: Scalars['String'];
  range?: InputMaybe<RangeInput>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>>>;
};


export type QueryTaxonomyTermQueryArgs = {
  filter?: InputMaybe<EntityQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<EntityQuerySortInput>>>;
};

export enum QueryOperator {
  Equal = 'EQUAL',
  NotEqual = 'NOT_EQUAL'
}

export type RangeInput = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type SearchApiSearch = {
  __typename?: 'SearchAPISearch';
  documents?: Maybe<Array<Maybe<DefaultIndexDoc>>>;
  facets?: Maybe<Array<Maybe<Facets>>>;
  result_count?: Maybe<Scalars['Int']>;
};

export type SortInput = {
  field: Scalars['String'];
  value: Scalars['String'];
};

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type TaxonomyTerm = Entity & {
  __typename?: 'TaxonomyTerm';
  weight?: Maybe<Scalars['Int']>;
};

export type TaxonomyTermAbout = Entity & {
  __typename?: 'TaxonomyTermAbout';
  description?: Maybe<Description>;
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
  queryParent?: Maybe<Array<Maybe<Parent>>>;
};

export type TaxonomyTermPages = Entity & {
  __typename?: 'TaxonomyTermPages';
  description?: Maybe<Description>;
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
  fieldPoster?: Maybe<Url>;
  queryParent?: Maybe<Array<Maybe<Parent>>>;
};

export type TaxonomyTermPartners = Entity & {
  __typename?: 'TaxonomyTermPartners';
  description?: Maybe<Description>;
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
  fieldExternalLink?: Maybe<ExternalLink>;
  fieldLogo?: Maybe<Url>;
  fieldLogoMargin?: Maybe<Scalars['Boolean']>;
  fieldPoster?: Maybe<Url>;
  fieldShortDescription?: Maybe<Scalars['String']>;
  fieldSubtitle?: Maybe<Scalars['String']>;
  fieldTags?: Maybe<Array<Maybe<FieldTags>>>;
  fieldVideoId?: Maybe<Scalars['String']>;
  fieldVideoPlatform?: Maybe<FieldVideoPlatform>;
  queryParent?: Maybe<Array<Maybe<Parent>>>;
};

export type TaxonomyTermQuestions = Entity & {
  __typename?: 'TaxonomyTermQuestions';
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
  fieldPoster?: Maybe<Url>;
  queryParent?: Maybe<Array<Maybe<Parent>>>;
};

export type TaxonomyTermSchools = Entity & {
  __typename?: 'TaxonomyTermSchools';
  description?: Maybe<Description>;
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
  fieldExternalLink?: Maybe<ExternalLink>;
  fieldLogo?: Maybe<Url>;
  fieldLogoMargin?: Maybe<Scalars['Boolean']>;
  fieldPoster?: Maybe<Url>;
  fieldShortDescription?: Maybe<Scalars['String']>;
  fieldSubtitle?: Maybe<Scalars['String']>;
  fieldTags?: Maybe<Array<Maybe<FieldTags>>>;
  fieldVideoId?: Maybe<Scalars['String']>;
  fieldVideoPlatform?: Maybe<FieldVideoPlatform>;
  queryParent?: Maybe<Array<Maybe<Parent>>>;
};

export type TaxonomyTermSubpages = Entity & {
  __typename?: 'TaxonomyTermSubpages';
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
  fieldTooltip?: Maybe<Scalars['String']>;
  queryParent?: Maybe<Array<Maybe<Parent>>>;
};

export type TaxonomyTermTags = Entity & {
  __typename?: 'TaxonomyTermTags';
  entityBundle?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityLabel?: Maybe<Scalars['String']>;
  entityUrl?: Maybe<Path>;
};

export type Url = {
  __typename?: 'Url';
  url?: Maybe<Scalars['String']>;
};

export type SearchQueryVariables = Exact<{
  index_id: Scalars['String'];
  fulltext?: InputMaybe<FulltextInput>;
  facets?: InputMaybe<Array<InputMaybe<FacetInput>> | InputMaybe<FacetInput>>;
  conditions?: InputMaybe<Array<InputMaybe<ConditionInput>> | InputMaybe<ConditionInput>>;
  condition_group?: InputMaybe<ConditionGroupInput>;
  range?: InputMaybe<RangeInput>;
  sort?: InputMaybe<Array<InputMaybe<SortInput>> | InputMaybe<SortInput>>;
}>;


export type SearchQuery = { __typename?: 'Query', searchAPISearch?: { __typename?: 'SearchAPISearch', result_count?: number | null, facets?: Array<{ __typename?: 'Facets', name?: string | null, values?: Array<{ __typename?: 'FacetsValue', filter?: string | null, count?: number | null } | null> | null } | null> | null, documents?: Array<{ __typename?: 'DefaultIndexDoc', id?: string | null, published?: string | null, url: string, title?: string | null, field_sub_title?: string | null, summary?: string | null, field_short_description?: string | null, body?: string | null, stitky?: Array<number | null> | null, page_name?: Array<string | null> | null, page_name_1?: Array<string | null> | null, created?: number | null, field_video_platform?: number | null, field_video_id?: string | null, comment?: number | null, field_image_url?: string | null, field_image_url_1?: string | null, field_image_position_1?: string | null, field_image_position_2?: string | null, field_logo_1?: string | null, field_logo_margin_1?: boolean | null, field_logo_2?: string | null, field_logo_margin_2?: boolean | null, field_logo_3?: string | null, field_logo_margin_3?: boolean | null, field_logo_4?: string | null, field_logo_margin_4?: boolean | null, path_page?: Array<string | null> | null, path_school?: string | null, path_partners?: string | null, path_people?: string | null, path_questions?: string | null, content_type?: string | null, content_type_1?: string | null, field_recommended?: string | null, field_recommended_ukrajinu?: string | null, field_homepage?: string | null, skoly?: Array<number | null> | null, partneri?: Array<number | null> | null, type?: string | null, field_summary?: string | null, weight?: number | null } | null> | null } | null };

export type TaxonomyQueryVariables = Exact<{
  filter?: InputMaybe<EntityQueryFilterInput>;
  limit?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Array<InputMaybe<EntityQuerySortInput>> | InputMaybe<EntityQuerySortInput>>;
}>;


export type TaxonomyQuery = { __typename?: 'Query', taxonomyTermQuery?: { __typename?: 'EntityQueryResult', entities?: Array<{ __typename?: 'TaxonomyTerm', weight?: number | null } | { __typename?: 'TaxonomyTermAbout', entityId?: string | null, entityLabel?: string | null, entityBundle?: string | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null, queryParent?: Array<{ __typename?: 'Parent', entities?: Array<{ __typename?: 'ParentEntity', entityId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'Description', value?: string | null } | null } | { __typename?: 'TaxonomyTermPages', entityId?: string | null, entityLabel?: string | null, entityBundle?: string | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null, queryParent?: Array<{ __typename?: 'Parent', entities?: Array<{ __typename?: 'ParentEntity', entityId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'Description', value?: string | null } | null, fieldPoster?: { __typename?: 'Url', url?: string | null } | null } | { __typename?: 'TaxonomyTermPartners', entityId?: string | null, entityLabel?: string | null, fieldSubtitle?: string | null, entityBundle?: string | null, fieldShortDescription?: string | null, fieldVideoId?: string | null, fieldLogoMargin?: boolean | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null, queryParent?: Array<{ __typename?: 'Parent', entities?: Array<{ __typename?: 'ParentEntity', entityId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'Description', value?: string | null } | null, fieldPoster?: { __typename?: 'Url', url?: string | null } | null, fieldTags?: Array<{ __typename?: 'FieldTags', targetId?: number | null } | null> | null, fieldVideoPlatform?: { __typename?: 'FieldVideoPlatform', targetId?: number | null } | null, fieldExternalLink?: { __typename?: 'ExternalLink', title?: string | null, url?: { __typename?: 'Path', path?: string | null } | null } | null, fieldLogo?: { __typename?: 'Url', url?: string | null } | null } | { __typename?: 'TaxonomyTermQuestions', entityId?: string | null, entityLabel?: string | null, entityBundle?: string | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null, queryParent?: Array<{ __typename?: 'Parent', entities?: Array<{ __typename?: 'ParentEntity', entityId?: string | null } | null> | null } | null> | null, fieldPoster?: { __typename?: 'Url', url?: string | null } | null } | { __typename?: 'TaxonomyTermSchools', entityId?: string | null, entityLabel?: string | null, fieldSubtitle?: string | null, entityBundle?: string | null, fieldShortDescription?: string | null, fieldVideoId?: string | null, fieldLogoMargin?: boolean | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null, queryParent?: Array<{ __typename?: 'Parent', entities?: Array<{ __typename?: 'ParentEntity', entityId?: string | null } | null> | null } | null> | null, description?: { __typename?: 'Description', value?: string | null } | null, fieldPoster?: { __typename?: 'Url', url?: string | null } | null, fieldTags?: Array<{ __typename?: 'FieldTags', targetId?: number | null } | null> | null, fieldVideoPlatform?: { __typename?: 'FieldVideoPlatform', targetId?: number | null } | null, fieldExternalLink?: { __typename?: 'ExternalLink', title?: string | null, url?: { __typename?: 'Path', path?: string | null } | null } | null, fieldLogo?: { __typename?: 'Url', url?: string | null } | null } | { __typename?: 'TaxonomyTermSubpages', entityBundle?: string | null, entityId?: string | null, entityLabel?: string | null, fieldTooltip?: string | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null, queryParent?: Array<{ __typename?: 'Parent', entities?: Array<{ __typename?: 'ParentEntity', entityId?: string | null } | null> | null } | null> | null } | { __typename?: 'TaxonomyTermTags', entityId?: string | null, entityLabel?: string | null, entityBundle?: string | null, entityUrl?: { __typename?: 'Path', path?: string | null } | null } | null> | null } | null };

export const SearchDocument = gql`
    query search($index_id: String!, $fulltext: FulltextInput, $facets: [FacetInput], $conditions: [ConditionInput], $condition_group: ConditionGroupInput, $range: RangeInput, $sort: [SortInput]) {
  searchAPISearch(
    index_id: $index_id
    fulltext: $fulltext
    facets: $facets
    conditions: $conditions
    condition_group: $condition_group
    range: $range
    sort: $sort
  ) {
    result_count
    facets {
      name
      values {
        filter
        count
      }
    }
    documents {
      ... on DefaultIndexDoc {
        id
        published
        url
        title
        field_sub_title
        summary
        field_short_description
        body
        stitky
        page_name
        page_name_1
        created
        field_video_platform
        field_video_id
        comment
        field_image_url
        field_image_url_1
        field_image_position_1
        field_image_position_2
        field_logo_1
        field_logo_margin_1
        field_logo_2
        field_logo_margin_2
        field_logo_3
        field_logo_margin_3
        field_logo_4
        field_logo_margin_4
        path_page
        path_school
        path_partners
        path_people
        path_questions
        content_type
        content_type_1
        field_recommended
        field_recommended_ukrajinu
        field_homepage
        skoly
        partneri
        type
        field_summary
        weight
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchGQL extends Apollo.Query<SearchQuery, SearchQueryVariables> {
    document = SearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TaxonomyDocument = gql`
    query taxonomy($filter: EntityQueryFilterInput, $limit: Int, $sort: [EntityQuerySortInput]) {
  taxonomyTermQuery(filter: $filter, limit: $limit, sort: $sort) {
    entities {
      ... on TaxonomyTerm {
        weight
      }
      ... on TaxonomyTermPages {
        entityId
        entityLabel
        entityUrl {
          path
        }
        entityBundle
        queryParent {
          entities {
            entityId
          }
        }
        description {
          value
        }
        fieldPoster {
          url
        }
      }
      ... on TaxonomyTermAbout {
        entityId
        entityLabel
        entityUrl {
          path
        }
        entityBundle
        queryParent {
          entities {
            entityId
          }
        }
        description {
          value
        }
      }
      ... on TaxonomyTermSchools {
        entityId
        entityLabel
        fieldSubtitle
        entityUrl {
          path
        }
        entityBundle
        queryParent {
          entities {
            entityId
          }
        }
        fieldShortDescription
        description {
          value
        }
        fieldPoster {
          url
        }
        fieldTags {
          targetId
        }
        fieldVideoPlatform {
          targetId
        }
        fieldVideoId
        fieldExternalLink {
          url {
            path
          }
          title
        }
        fieldLogo {
          url
        }
        fieldLogoMargin
      }
      ... on TaxonomyTermPartners {
        entityId
        entityLabel
        fieldSubtitle
        entityUrl {
          path
        }
        entityBundle
        queryParent {
          entities {
            entityId
          }
        }
        fieldShortDescription
        description {
          value
        }
        fieldPoster {
          url
        }
        fieldTags {
          targetId
        }
        fieldVideoPlatform {
          targetId
        }
        fieldVideoId
        fieldExternalLink {
          url {
            path
          }
          title
        }
        fieldLogo {
          url
        }
        fieldLogoMargin
      }
      ... on TaxonomyTermQuestions {
        entityId
        entityLabel
        entityUrl {
          path
        }
        entityBundle
        queryParent {
          entities {
            entityId
          }
        }
        fieldPoster {
          url
        }
      }
      ... on TaxonomyTermTags {
        entityId
        entityLabel
        entityUrl {
          path
        }
        entityBundle
      }
      ... on TaxonomyTermSubpages {
        entityBundle
        entityId
        entityLabel
        fieldTooltip
        entityUrl {
          path
        }
        queryParent {
          entities {
            entityId
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TaxonomyGQL extends Apollo.Query<TaxonomyQuery, TaxonomyQueryVariables> {
    document = TaxonomyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }